export const SHOW_ALERT_MESSAGE = "SHOW_ALERT_MESSAGE"
export const SHOW_ALERT_MESSAGE_INFO = "SHOW_ALERT_MESSAGE_INFO"

